export default function (state, data) {
    state.items = [];
    state.time = new Date().getTime() + (60 * 60 * 1000);
    if (data && data.Items) {
        data.Items.forEach(i => {
            if (i.Id === 0) return;
            state.items.push({
                value: i.Id,
                label: i.Name,
                category: i.CategoryId,
            });
        });
    } else {
        state.time = 0;
    }
    state.loading = false;
    state.cbs.forEach(i => {
        i(state);
    });
    state.cbs = [];
}